import { render, staticRenderFns } from "./FormRacis.vue?vue&type=template&id=054fd396&scoped=true"
import script from "./FormRacis.vue?vue&type=script&lang=js"
export * from "./FormRacis.vue?vue&type=script&lang=js"
import style0 from "./FormRacis.vue?vue&type=style&index=0&id=054fd396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054fd396",
  null
  
)

export default component.exports